import { capitalizeFirstName, sanitizeInnerHtml } from "@/utils/helper"
import React, { useEffect, useRef, useState } from "react"
import { isMobile } from "react-device-detect"
import { getUserMenuFragmentEventInfo } from "@/components/Default/AuthUtilityNav/v1/MegaMenu/analytics"
import styles from "@/components/Default/CountryUtilNav/v1/CountryUtilNav.module.scss"

import closeWhite from "@/public/icons/close-white.svg"
import users from "@/public/icons/avatarblack.svg"
import avatar from "@/public/icons/new-avatar.svg"

// const isMobile =
//   window.outerWidth === 0
//     ? window.innerWidth <= 1200
//     : isSafari
//     ? window.innerWidth <= 1200
//     : window.outerWidth <= 1200

const MegaMenu = props => {
  const {
    userMenuFragment,
    guestMenuFragment,
    isLoggedIn,
    i18n,
    user,
    logout,
    toggleAuthNav,
    handleSignin,
    handleCreateAccount,
    onAuthMenuClick,
    nomenu,
    setCloseAuthMenu = () => {},
  } = props

  const signOutEventInfo = JSON.stringify({
    eventName: "my account:sign out",
    eventAction: "my account:sign out",
    internalLinkName: "sign out",
    internalLinkType: "global header:navigation",
    internalLinkZoneName: "global header",
    clickInternalLinks: "true",
    eventType: "navigation",
    internalLinkURL: window.location.origin + "/en",
    internalLinkPosition: "global header sign out",
    eventMsg: "n/a",
    eventStatus: "n/a",
  })

  const leftArrow = "/icons/left-arrow-white.svg"
  const name = user && user?.firstName
  const modalWindow = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const handleKeyPress = () => {
    if (userMenuFragment) {
      addAnalyticsUserMenuFragment()
    }
  }

  useEffect(() => {
    window.addEventListener("click", handleKeyPress)

    modalWindow.current.focus()
    if (userMenuFragment) {
      addAnalyticsUserMenuFragment()
    }
    return () => {
      window.removeEventListener("click", handleKeyPress)
    }
  })

  const addAnalyticsUserMenuFragment = () => {
    setTimeout(() => {
      modalWindow.current.querySelectorAll("p a").forEach(link => {
        link.classList.add("gbh-data-layer")
        const textContent =
          link?.textContent ||
          (link.querySelector("u") ? link.querySelector("u").textContent : "")
        const eventInfo = getUserMenuFragmentEventInfo(
          textContent?.toLowerCase()
        )
        link.setAttribute("data-gbh-data-layer", eventInfo)
      })
    })
  }

  const handleOrdersClick = () => {
    const cartUrl = `${window.location.origin}/orders/order-status`
    window.location.href = cartUrl
  }

  const handleOpenMenu = () => {
    document.getElementsByClassName("gbh-nav__findStore")[0].style.display =
      "none"
    document.getElementsByClassName(
      "gbh-nav__region region_arrowdropdown"
    )[0].style.display = "none"
    setIsOpen(true)
  }

  const styleVariable = {
    fontFamily: "Helvetica Now Text W05 Light",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 300,
    lineHeight: "40px" /* 125% */,
    letterSpacing: "-2.2px",
    color: "#FFFFFF",
  }

  return (
    <>
      <div className="container kf-react-container">
        {nomenu && (
          <div className="user-auth-menu">
            <div>
              <img src={users.src} alt="user" className="user-icon" />
            </div>
            <div
              onClick={() => {
                setCloseAuthMenu(false)
              }}
            >
              <img
                className="close-menu"
                src={closeWhite.src}
                alt="close-icon"
              />
            </div>
          </div>
        )}
        {isMobile && isLoggedIn && !nomenu && (
          <div
            tabIndex="0"
            role="button"
            id="auth-nav__menu-mobile-back"
            className="auth-nav__menu-mobile-back-menu"
            onClick={() => {
              toggleAuthNav()
              onAuthMenuClick(false)
            }}
          >
            <img
              className="leftArrow-img"
              src={leftArrow}
              alt={i18n.leftArrowAlt}
            />
            <span>{i18n.menu}</span>
          </div>
        )}
        <div id="auth-nav__menu-wrap" className="auth-nav__menu-wrap">
          <div className="auth-nav__menu-title">
            {isLoggedIn ? `Hi ${name}!` : i18n.title}
          </div>
          <div className="auth-nav-menu-title">
            <span>
              {nomenu ? `Hi, ${capitalizeFirstName(user?.firstName)}` : null}
            </span>
          </div>
          <div className="auth-nav__menu-items" role="list">
            {!isLoggedIn && !isMobile && (
              <span role="list-item">
                <a
                  role="button"
                  name="signin"
                  id="kf-react-sign-in"
                  onClick={handleSignin}
                  className="gbh-data-layer"
                  data-gbh-data-layer='{"eventName":"my account:sign in","eventAction":"my account:sign in","internalLinkName":"sign in interaction","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header sign in","eventMsg":"n/a","eventStatus":"n/a"}'
                >
                  {i18n.signIn}
                </a>
                <br />
              </span>
            )}
            {!isLoggedIn && !isMobile && (
              <span role="list-item">
                <a
                  role="button"
                  className="gbh-data-layer"
                  id="kf-react-sign-up"
                  name="create-account"
                  data-gbh-data-layer='{"eventName":"my account:create account","eventAction":"my account:create account","internalLinkName":"create account","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header create account","eventMsg":"n/a","eventStatus":"n/a"}'
                  onClick={handleCreateAccount}
                >
                  {i18n.createAccount}
                </a>
                <br />
              </span>
            )}
            {!isLoggedIn && !isMobile && (
              <span role="list-item">
                <a
                  role="button"
                  className="gbh-data-layer"
                  id="kf-react-sign-up"
                  name="create-account"
                  data-gbh-data-layer='{"eventName":"my account:orders","eventAction":"my account:orders","internalLinkName":"orders","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header create account","eventMsg":"n/a","eventStatus":"n/a"}'
                  onClick={handleOrdersClick}
                >
                  {i18n.orders}
                </a>
                <br />
              </span>
            )}
            {!isLoggedIn && isMobile && (
              <span role="listitem">
                <span role="list-item">
                  <button
                    role="button"
                    onClick={handleOpenMenu}
                    className="gbh-data-layer bg-transparent auth-nav__sign-in-button"
                  >
                    <img
                      className="gbh-data-layer auth-nav__sign-in-mobile-avatar"
                      alt="auth-nav"
                      src={avatar.src}
                    />
                  </button>
                </span>
              </span>
            )}
            <div
              role="list-item"
              data-gbh-data-layer={addAnalyticsUserMenuFragment}
              ref={modalWindow}
              onClick={handleKeyPress}
            >
              {sanitizeInnerHtml(
                isLoggedIn ? userMenuFragment : guestMenuFragment
              )}
            </div>
            {isLoggedIn && (
              <span className="sign-out">
                <a
                  role="button"
                  onClick={logout}
                  className="gbh-data-layer"
                  data-gbh-data-layer={signOutEventInfo}
                >
                  {i18n.logout}
                </a>
                <br />
              </span>
            )}
          </div>
        </div>
      </div>
      {isOpen && (
        <div
          className={styles.countrySelectorMain}
          data-testid="countrySelectorSection"
        >
          <div
            id="gbh_utheader"
            className={`gbh-countryselector ${isOpen ? "active" : ""}`}
            style={{ left: 0, display: "block", right: 0 }}
          >
            <div className="gbh-tab">
              <div
                role="button"
                tabIndex="0"
                className="gbh-close-btn d-block d-lg-none pl-4 mb-2"
                onClick={() => {
                  setIsOpen(false)
                  document.getElementsByClassName(
                    "gbh-nav__findStore"
                  )[0].style.display = "list-item"
                  document.getElementsByClassName(
                    "gbh-nav__region region_arrowdropdown"
                  )[0].style.display = "list-item"
                }}
              >
                Menu
              </div>
              <ul
                role="tablist"
                aria-multiselectable="false"
                className="tablist"
              >
                <div className="selection-bar">
                  <li className="gbh-tabs__tab">
                    <a
                      role="button"
                      name="signin"
                      id="kf-react-sign-in"
                      onClick={handleSignin}
                      className="gbh-data-layer"
                      data-gbh-data-layer='{"eventName":"my account:sign in","eventAction":"my account:sign in","internalLinkName":"sign in interaction","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header sign in","eventMsg":"n/a","eventStatus":"n/a"}'
                      style={styleVariable}
                    >
                      {i18n.signIn}
                    </a>
                    <br />
                  </li>
                  <li className="gbh-tabs__tab">
                    <a
                      role="button"
                      className="gbh-data-layer"
                      id="kf-react-sign-up"
                      name="create-account"
                      data-gbh-data-layer='{"eventName":"my account:create account","eventAction":"my account:create account","internalLinkName":"create account","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header create account","eventMsg":"n/a","eventStatus":"n/a"}'
                      onClick={handleCreateAccount}
                      style={styleVariable}
                    >
                      {i18n.createAccount}
                    </a>
                    <br />
                  </li>
                  <li className="gbh-tabs__tab">
                    <a
                      role="button"
                      className="gbh-data-layer"
                      id="kf-react-sign-up"
                      name="create-account"
                      data-gbh-data-layer='{"eventName":"my account:create account","eventAction":"my account:create account","internalLinkName":"create account","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header create account","eventMsg":"n/a","eventStatus":"n/a"}'
                      onClick={handleOrdersClick}
                      style={styleVariable}
                    >
                      {i18n.orders}
                    </a>
                    <br />
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MegaMenu
